import BmsmChart from './BmsmChart';

export default BmsmChart;
